var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-layout',[_c('timeoff-sidebar-item',{staticClass:"sidebar-container",attrs:{"timeoff":_vm.entity}}),_c('timeoff-footer',{attrs:{"slot":"footer","index":_vm.entity.index,"route":_vm.route},slot:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }